"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniversalSubmission = void 0;
const runtypes_1 = require("runtypes");
const languages_1 = require("./languages");
const submission_1 = require("./submission");
exports.UniversalSubmission = (0, runtypes_1.Record)({
    type: submission_1.SubmissionType,
    id: runtypes_1.String,
    timestamp: (0, runtypes_1.InstanceOf)(Date),
    question: (0, runtypes_1.Record)({
        language: languages_1.Languages,
        path: runtypes_1.String,
    }).And((0, runtypes_1.Partial)({
        author: runtypes_1.String,
        version: runtypes_1.String,
        contentHash: runtypes_1.String,
    })),
    contents: runtypes_1.String,
    results: runtypes_1.Unknown,
}).And((0, runtypes_1.Partial)({
    email: runtypes_1.String,
    browserID: runtypes_1.String,
}));
//# sourceMappingURL=universal.js.map